<template>
  <div v-if="event_group" style="display: contents;">
    <div class="loading" v-show="!active">
      <k-progress-circular class="loading-icon" indeterminate v-bind:size="50"></k-progress-circular>
    </div>

    <div v-if="active" style="background-color: rgba(0,0,0,0.2); border-radius: 6px; margin: 3px; padding-left: 15px; padding-right: 15px; padding-bottom: 0px; height: 40px; margin-bottom: var(--ks-margin-2);">
      <k-autocomplete v-model="selected_event" @change="select_event" :items="events" :item-text="title" placeholder="Select schedule event" clearable item-value="uuid"></k-autocomplete>
    </div>


    <template v-if="active && !selected_event">
      <EventForm :disable_event_group_edit="true" :event_group="event_group.uuid" :disable_get_profile="true"></EventForm>
    </template>
    <template v-if="active && selected_event">
      <EventForm :disable_event_group_edit="true" :id="selected_event" :key="selected_event" :disable_get_profile="true"></EventForm>
    </template>
  </div>
</template>

<script>

import EventForm from './Form'
import ChannelModel from '@/models/channel.js'
import EventModel from '@/models/event.js'

export default {
  props: ['id'],
  components: {
    EventForm
  },
  data () {
    var ch = undefined;
    if(this.id) ch = this.$cloudserver.channel("events:event_group_by_event:"+this.id);
    return {
      ws_channel: ch,
      events: undefined,
      event_group: undefined,
      active: this.$route.query.tab == "schedule",
      selected_event: this.$route.query.event,
    }
  },
  watch: {
    id (newVal, oldVal) {
      if (!oldVal && newVal && !this.ws_channel) {
        if (this.ws_channel) this.ws_channel.leave();
        this.ws_channel = this.$cloudserver.channel("events:event_group_by_event:"+newVal);
        this.ws_channel.join();
      }
    },
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.event_group = newVal;
          this.events = this.event_group["events"] || [];
        }
      },
      deep: true
    },
    "$route.query.tab" (newVal) {
      if(newVal == "schedule") {
        setTimeout(() => {
          this.active = true;
        },200);
      }
    },
    "$route.query.event" (newVal) {
      this.selected_event = newVal;
    }
  },
  created () {
    if(this.ws_channel) this.ws_channel.join();
    this.$store.dispatch("get_profile");
  },
  methods: {
    select_event(event) {
      if (event == null || typeof(event) == "undefined") {
        this.$router.push("/dashboard/event/" + this.id + "?tab=schedule");
      } else {
        this.$router.push("/dashboard/event/" + this.id + "?tab=schedule&event=" + event);
      }
    },
    save(close) {

    },
    title (event) {
      var ch = EventModel.output_channel(event);
      return ChannelModel.title(ch) + ": " + EventModel.title(event);
    }
  }

}
</script>

<style scoped>
.loading {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: var(--ks-z-loading, 7);
}
.loading .loading-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
}
</style>
